import styled from 'styled-components'

export const CatalogItemDetailsSourceIconStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
`
